import _default from './Checkbox';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/modules/Checkbox/index.js
// module id = 119
// module chunks = 0